import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../app/services/authentication.service';
import { Observable } from 'rxjs';

@Injectable()
export class AdminguardGuard implements CanActivate, CanActivateChild  {
  constructor(private Authentication: AuthenticationService, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

      if (sessionStorage.getItem('AdminLogged')) {
        return true;
      } 
      this.router.navigate([this.Authentication.GetAdminLoginUrl()]);
      return false;
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      if (sessionStorage.getItem('AdminLogged')) {
        return true;
      } 
      this.router.navigate([this.Authentication.GetAdminLoginUrl()]);
      return false;
  }
}
